/**
 * @description: 原生客户端 API 接口管理文件
 * 所有接口变量定义均以: '_API' 结尾
 * 在每个接口上面写好接口用途注释
 */

export default {
	// 会员框架-主页面数据接口
	GET_MEMBERSHIP_PAGE_INFO: '/vip/rechargeEntrancePage',
	// 会员框架-创建订单接口
	CREATE_MEMBER_ORDER_API: '/Order/CreateMemberOrder',
	// 会员框架-续费套餐检测接口
	CHECK_RENEW_USEFUL_API: '/Order/checkCreateRenewOrder',
	// 会员框架-支付结果弹窗
	GET_MEMBER_PAY_MODAL_API: '/Vip/PayPopWindow',
	// 解除自动续约
	CONTRACT_UNSIGN: '/Vip/ContractUnsign',
};



// WEBPACK FOOTER //
// ./src/service/api/modules/membership.js